import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const createUser = async (body) => {
  const { data } = await axiosInstance.post('/promethee_admin/users/', body);
  return data;
};

export const useCreateUser = (options = {}) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: createUser,
    onSuccess: (data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
      options.onSuccess?.(data, vars);
    },
    onError: options.onError,
  });
  return { createUser: mutation.mutateAsync, ...mutation };
};
